<template>
    <div :class="css" :styles="styles">
        <div class="nj-label">{{ text }}</div>
        <slot></slot>
    </div>
</template>
<script>
export default {
    name: "InputForm",
    props: {
        text: {
            type: String,
        }
    },
    data() {
        return {
            css: {
                type: String,
                default: "",
            },
            styles: {
                type: String,
                default: "",
            }
        }
    },
    computed: {

    },
    methods: {

    },
    mounted() {

    }
}
</script>

<style scoped></style>